import { EFieldType } from '@lib-shared/fields/types/enums/field-type';
import { IField } from '@/document-edit/assembler/fields/types/field';
import { defaultDropdownOption } from '@signing-page/fields/constants/field-placeholders';

export class FieldHelper {
  private static validateValue(validationRegex: string, value: string): boolean {
    return new RegExp(validationRegex).test(value);
  }

  static fieldCompleted(field: IField, verifiedInitialFieldIds?: string[]): boolean {
    switch (field.type) {
      case EFieldType.Formatted:
        return !!field.value && !!this.validateValue(field.validationRegex, field.value);
      case EFieldType.Check:
        return field.value === '1';
      case EFieldType.Initials:
        return verifiedInitialFieldIds?.includes(field.id) || false;
      case EFieldType.Signature:
        return !!field.label;
      case EFieldType.Dropdown:
        return !field.value || field.value === defaultDropdownOption ? false : true;
      default:
        return !!field.value;
    }
  }

  static isInputField(fieldType: EFieldType): boolean {
    switch (fieldType) {
      case EFieldType.Check:
      case EFieldType.Dropdown:
      case EFieldType.Signature:
      case EFieldType.Text:
      case EFieldType.Formatted:
      case EFieldType.Initials:
        return true;
      default:
        return false;
    }
  }

  static isTabbableField(fieldType: EFieldType): boolean {
    switch (fieldType) {
      case EFieldType.Check:
      case EFieldType.Dropdown:
      case EFieldType.Link:
      case EFieldType.Signature:
      case EFieldType.Text:
      case EFieldType.Formatted:
      case EFieldType.Initials:
        return true;
      default:
        return false;
    }
  }

  static showFieldTooltip(
    type: EFieldType,
    disabled: boolean,
    requiredStepsLeft: boolean
  ): boolean {
    if ([EFieldType.Merge, EFieldType.Link].includes(type)) {
      return false;
    }

    if (disabled) {
      return true;
    }

    if (type === EFieldType.Signature) {
      return requiredStepsLeft;
    }

    return false;
  }
}
